import { render, staticRenderFns } from "./SettingsPayments.vue?vue&type=template&id=6225fcfe&"
import script from "./SettingsPayments.vue?vue&type=script&lang=js&"
export * from "./SettingsPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports